var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.21342 8.4675C9.07278 8.32689 8.88204 8.24791 8.68317 8.24791C8.4843 8.24791 8.29357 8.32689 8.15292 8.4675L6.76242 9.857L6.74992 0.75C6.74992 0.551087 6.6709 0.360322 6.53025 0.21967C6.3896 0.0790176 6.19883 0 5.99992 0V0C5.80101 0 5.61024 0.0790176 5.46959 0.21967C5.32894 0.360322 5.24992 0.551087 5.24992 0.75L5.26142 9.85L3.87992 8.4675C3.73847 8.33088 3.54902 8.25528 3.35237 8.25699C3.15572 8.2587 2.96761 8.33758 2.82856 8.47663C2.6895 8.61569 2.61062 8.8038 2.60892 9.00045C2.60721 9.19709 2.6828 9.38655 2.81942 9.528L4.77892 11.4875C5.10709 11.8156 5.55213 11.9999 6.01617 11.9999C6.48021 11.9999 6.92525 11.8156 7.25342 11.4875L9.21342 9.528C9.35402 9.38735 9.43301 9.19662 9.43301 8.99775C9.43301 8.79887 9.35402 8.60814 9.21342 8.4675Z",
    fill: "#495057"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowGrey);
export default __webpack_public_path__ + "static/media/downArrowGrey.f0f0aafa78092e02bf09311d704b4129.svg";
export { ForwardRef as ReactComponent };